// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"1dbd7913","237":"b07c4fd7","240":"ac0964d8","470":"86f2564e","703":"d8cb8f6f"}[chunkId] + ".chunk.css";
};